var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"label":"Нужно фильтровать"},model:{value:(_vm.need),callback:function ($$v) {_vm.need=$$v},expression:"need"}}),_vm._v(" "),_c('v-btn',{staticClass:"success",on:{"click":_vm.saveFilter}},[_vm._v("Сохранить")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0affe0a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/attesation_info/student/Filter.vue
// module id = null
// module chunks = 